import { LazyLoader, Modal } from '@bp/ui-components';
import { Dayjs } from 'dayjs';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitutionDataEntry } from '../../../pages/Substitutions/Plan/PlanSubstitutions/utils';
import { SubstitutionForm } from '../forms/SubstitutionForm';
import { SubstitutionEventsTableType } from '../tables/SubstitutionEventsTable';
import styles from './SubstitutionModal.module.scss';

type SubstitutionModalProps = {
  isOpen: boolean;
  timetableStart: Dayjs;
  timetableEnd: Dayjs;
  currentEvent: SubstitutionEventsTableType;
  teacherEvents: Map<string, SubstitutionEventsTableType[]>;
  onClose: () => void;
};

export const SubstitutionModal = ({
  isOpen,
  timetableStart,
  timetableEnd,
  currentEvent,
  teacherEvents,
  onClose,
}: SubstitutionModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      fullWidth
      padding='s'
      className={styles['substitution-modal']}
      headerClasses={styles.header}
      contentClasses={styles.content}
      title={t('substitutions.substituteEvent', {
        timeGridEntryShortName: currentEvent?.timeGridEntryShortName,
        classes: currentEvent?.originalGroupClassNamesLong,
        subject: currentEvent?.subject.name,
      })}
      subtitle={`${currentEvent?.start.format('HH:mm')} - ${currentEvent?.end.format('HH:mm')}`}
      loading={loading}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <Suspense fallback={<LazyLoader embedded forceHeight='60vh' />}>
        {currentEvent && (
          <SubstitutionForm
            timetableStart={timetableStart}
            timetableEnd={timetableEnd}
            currentEvent={currentEvent}
            teacherEvents={teacherEvents}
            onLoad={setLoading}
            onClose={onClose}
          />
        )}
      </Suspense>
    </Modal>
  );
};
